import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconParachute: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconParachute"><Path fillRule="evenodd" clipRule="evenodd" d="M20.6892 12.7812C17.94 11.0385 15.3246 10.1161 12.75 9.96631V16H15V16.9533L20.6892 12.7812ZM15 18.8134L22.75 13.1301V12.75C22.75 6.81294 17.9371 2 12 2C6.06294 2 1.25 6.81294 1.25 12.75V13.1301L9 18.8134V22H15V18.8134ZM11.25 16V9.96631C8.67535 10.1161 6.05999 11.0385 3.31084 12.7812L9 16.9533V16H11.25Z" fill="currentColor"/></CentralIconBase>;
});

export default IconParachute;
